import "./styles.css";

const EvaluationListItems = ({ results = [], propNam }) => {
  const lists = results.map((result, index) => {

    console.log("Result comments", result, propNam, result[propNam]);

    return (
      <div className="evaluation__list--item" title={result[propNam]}>
        {index + 1}. {result[propNam]}
      </div>
    );
  });

  return (
    <div className="evaluation__list--items">
      {lists}
    </div>
  );
}

export default EvaluationListItems;